<template>
  <toolbar-button :button-text="buttonText" class="trix-button--icon" :class="iconClass" />
</template>

<script>
import ToolbarButton from './button'

export default {
  components: { ToolbarButton },

  props: {
    buttonText: {
      type: String,
      required: true
    },

    iconKey: {
      type: String,
      required: true
    }
  },

  computed: {
    iconClass() {
      return `trix-button--icon-${this.iconKey}`
    }
  }
}
</script>
